import React from 'react';
import { HallowComponent } from './HallowComponent';
import { HallowImage } from './HallowImage';
import { HallowAudio } from './AudioPlayer';
import './prayer.css';

export const Prayer = class Prayer extends HallowComponent {
    // required props: type ('sample' or 'full'), id (prayer #)
    // optional props: prayer (otherwise we get from ID)

    state = {
        prayer: this.props.prayer
    }

    componentDidMount() {
        if (!this.state.prayer) {
            this.getAPI('prayers', this.props.id).then(prayer => {
                prayer.description = this.parseLinks(prayer.description);
                this.setState({prayer: prayer});
            });
        }
    }

    render() {
        const elementId = 'p' + this.props.id;
        if (this.state.prayer) {
            let audioProps = {
                id: elementId,
                url: this.state.prayer.audio_url,
                type: this.props.type,
            };
            if (this.props.type === 'sample') {
                audioProps.start = 0;
                audioProps.end = 120000;
                audioProps.duration = 120000;
            } else {
                audioProps.duration = null; // we have to get this from the audio element
            }

            return (
                <div className='prayer' id={elementId} key={this.generateChildKey('prayerWrapper')}>
                    <HallowImage raster={this.state.prayer.image_url} className='prayerImage' {...this.generateKeyProps('prayerImage')} />
                    <HallowAudio {...audioProps} {...this.generateKeyProps('prayerAudio')} />
                    <div className='info' key={this.generateChildKey('info')}>
                        <div className='titleDesc' key={this.generateChildKey('titleDesc')}>
                            <div className='prayerTitle' key={this.generateChildKey('title')}><h4>{this.state.prayer.title}</h4></div>
                            <div className='desc' key={this.generateChildKey('desc')} dangerouslySetInnerHTML={{__html: this.state.prayer.description}} />
                            {this.props.type === 'sample' && <div className='preview' key={this.generateChildKey('preview')}>2 min Preview</div>}
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default Prayer;